<template>
  <v-card elevation="0">
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="color: black; font-size: 15px;">
                    Nome Completo / Razão Social
                  </th>
                  <th class="text-left" style="color: black; font-size: 15px;">
                    CPF / CNPJ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(owner, index) in owners" :key="index">
                  <td>
                    <span v-if="!isPJ(owner)">
                      {{ owner.nome || defaultEmptyData }}
                    </span>
                    <span v-else>
                      {{ owner.socialName || owner.nome || defaultEmptyData }}
                    </span>
                  </td>
                  <td>
                    {{ formatCpfCnpj(owner.cpf_cnpj) || defaultEmptyData }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatCpfCnpj } from "@/modules/core/helpers/formatCpfCnpj";

const OwnerTypes = {
  PF: "PF",
  PJ: "PJ"
};

export default {
  props: {
    owners: {
      type: Array,
      require: true
    },
    socialName: String
  },
  data: () => ({
    defaultEmptyData: "Não informado"
  }),
  methods: {
    formatCpfCnpj,
    isPJ(owner) {
      if (owner.cpf_cnpj.length != 11) {
        owner.tipo = OwnerTypes.PJ;
      }
      return owner.tipo?.toUpperCase() === OwnerTypes.PJ;
    },
    getLabelNameByType(owner) {
      if (this.isPJ(owner)) {
        return null;
      } else {
        return this.$t("labels.full_name");
      }
    },
    getLabelIdentifyByType(owner) {
      if (this.isPJ(owner)) {
        return this.$t("labels.cnpj");
      }

      return this.$t("labels.cpf");
    }
  }
};
</script>

<style lang="scss" scoped>
.content-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 32px;
}

@media screen and (max-width: 960px) {
  .content-row {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .content-align-responsible {
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}
</style>
